import React from "react";
import './ContactForm.css';

const ContactForm = () => {
    return (
        <div className="contact-form-content">
            <form>
                <div className="name-container">
                    <input type="text" name="firstname" placeholder="$ firstname" />
                    <input type="text" name="lastname" placeholder="$ lastname" />
                </div>
                <input type="text" name="email" placeholder="$ email" />
                <textarea type="text" name="message" placeholder="$ message..." rows={4}></textarea>
                <button type="submit">send_message()</button>
            </form>
        </div>
    );
}

export default ContactForm;